import ClearIcon from "@mui/icons-material/Clear";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { MARGIN_GAP } from "../../lib/constants.js";

export default function PageListHeader({
  handleClearInput,
  handleInput,
  handleSort,
  isAscending,
  locales,
  pageName,
  searchBoxLabel,
  searchValue,
}) {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: MARGIN_GAP }}
    >
      <Grid>
        <TextField
          color="secondary"
          id={`${pageName}-search`}
          label={searchBoxLabel}
          onChange={handleInput}
          sx={{
            "& .MuiFilledInput-root": {
              backgroundColor: "backgroundContrast.main",
            },
            "& .MuiInputBase": {
              backgroundColor: "backgroundContrast.main",
            },
          }}
          value={searchValue}
          variant="filled"
          InputProps={{
            endAdornment: searchValue && (
              <IconButton
                aria-label={locales["search.clear"]}
                color="secondary"
                edge="end"
                onClick={handleClearInput}
                onMouseDown={handleClearInput}
              >
                <ClearIcon />
              </IconButton>
            ),
          }}
        />
      </Grid>
      <Grid>
        <Button
          color="secondary"
          endIcon={
            <TrendingFlatIcon
              sx={{
                transform: isAscending ? "rotate(90deg)" : "rotate(-90deg)",
              }}
            />
          }
          onClick={handleSort}
          size="large"
          variant="text"
        >
          {locales["sort"]}
        </Button>
      </Grid>
    </Grid>
  );
}
